/**
 * TransportV2 i18n catalogue.
 *
 * The T object is a flat key/value table, ported 1:1 from the original
 * design mock. useLang() persists the language in localStorage under
 * "iio-lang". t(key, vars) replaces {name} placeholders the same way the
 * mock does.
 */

import React, { useCallback, useEffect, useState } from "react";

export const T = {
  "hdr.title": { de: "Transport Wizard", en: "Transport Wizard" },
  "hdr.sub": { de: "Neuen Transport erstellen", en: "Create a new transport" },
  "hdr.conn": { de: "Verbunden", en: "Connected" },
  "user.role": { de: "Administrator", en: "Administrator" },
  "nav.work": { de: "Arbeitsbereich", en: "Workspace" },
  "nav.gov": { de: "Governance", en: "Governance" },
  "nav.admin": { de: "Administration", en: "Administration" },
  "nav.spaces": { de: "Spaces", en: "Spaces" },
  "nav.instances": { de: "Instanzen", en: "Instances" },
  "nav.transports": { de: "Transporte", en: "Transports" },
  "nav.monitor": { de: "Monitor", en: "Monitor" },
  "nav.builder": { de: "iFlow Builder", en: "iFlow Builder" },
  "nav.aibuilder": { de: "KI iFlow Builder", en: "AI iFlow Builder" },
  "nav.pipeline": { de: "Pipeline", en: "Pipeline" },
  "nav.entries": { de: "Transport Einträge", en: "Transport Entries" },
  "nav.alerting": { de: "Alerting", en: "Alerting" },
  "nav.pd": { de: "Partner Directory", en: "Partner Directory" },
  "nav.audit": { de: "Audit Log", en: "Audit Log" },
  "nav.docs": { de: "Dokumentation", en: "Documentation" },
  "nav.useradd": { de: "Benutzer anlegen", en: "Create User" },
  "nav.users": { de: "Benutzer verwalten", en: "Manage Users" },
  "nav.roles": { de: "Rollen & Berechtigungen", en: "Roles & Permissions" },
  "nav.cicd": { de: "CI/CD Setup", en: "CI/CD Setup" },
  "step0.l1": { de: "Space wählen", en: "Select Space" }, "step0.l2": { de: "Space auswählen", en: "Choose a space" },
  "step1.l1": { de: "Landschaften", en: "Landscapes" }, "step1.l2": { de: "Quell- & Ziel-Landschaften", en: "Source & target landscapes" },
  "step2.l1": { de: "Package", en: "Package" }, "step2.l2": { de: "Quelldaten definieren", en: "Define source data" },
  "step3.l1": { de: "Artefakte", en: "Artifacts" }, "step3.l2": { de: "Inhalte auswählen", en: "Select content" },
  "step4.l1": { de: "Konfiguration", en: "Configuration" }, "step4.l2": { de: "Parameter & Overrides", en: "Parameters & overrides" },
  "step5.l1": { de: "Review & Ausführung", en: "Review & Execution" }, "step5.l2": { de: "Prüfen & Transport starten", en: "Verify & start transport" },
  "common.back": { de: "Zurück", en: "Back" },
  "common.close": { de: "Schließen", en: "Close" },
  "s0.h2": { de: "Space wählen", en: "Select Space" },
  "s0.p": { de: "Spaces enthalten vordefinierte Systemlandschaften und Transportregeln.<br>Wählen Sie den Space aus, für den Sie einen Transport durchführen möchten.", en: "Spaces contain predefined system landscapes and transport rules.<br>Select the space you want to run a transport for." },
  "s0.status": { de: "Status", en: "Status" },
  "s0.active": { de: "Aktiv", en: "Active" },
  "s0.sys": { de: "Systeme", en: "Systems" },
  "s0.path": { de: "Transportpfad", en: "Transport path" },
  "s0.details": { de: "Space-Details: {name}", en: "Space details: {name}" },
  "col.space": { de: "Space", en: "Space" },
  "col.land": { de: "Systemlandschaften", en: "System landscapes" },
  "col.landsub": { de: "(vordefiniert)", en: "(predefined)" },
  "col.path": { de: "Transportpfad", en: "Transport path" },
  "col.ready": { de: "Bereitschaft", en: "Readiness" },
  "s0.pak": { de: "Pakete", en: "Packages" },
  "s0.art": { de: "Artefakte", en: "Artifacts" },
  "s0.ready": { de: "Bereit für Transport", en: "Ready for transport" },
  // Readiness column: pipeline setup status instead of package/artifact counts.
  "s0.readyRepo": { de: "Repository verbunden", en: "Repository connected" },
  "s0.readyRepoNo": { de: "Repository nicht verbunden", en: "Repository not connected" },
  "s0.readyWf": { de: "Workflow aktiv", en: "Workflow active" },
  "s0.readyWfNo": { de: "Workflow nicht aktiv", en: "Workflow not active" },
  "s0.readyStages": { de: "Stufen synchron", en: "Stages synchronized" },
  "s0.readyStagesNo": { de: "Stufen nicht synchron", en: "Stages not synchronized" },
  "s0.readyPending": { de: "Wird geprüft ...", en: "Checking ..." },
  "s0.readyOpen": { de: "Einrichtung offen", en: "Setup incomplete" },
  "s0.readyUnknown": { de: "Status nicht abrufbar", en: "Status unavailable" },
  "s0.werkeIn": { de: "{n} Werke im Ziel ({list})", en: "{n} plants in the target ({list})" },
  "s0.noW": { de: "Kein Werkstransport", en: "No plant transport" },
  "s0.pathsub": { de: "iFlow-Transport bis {code} · PROD per Freigabe", en: "iFlow transport up to {code} · PROD via approval" },
  "s0.info": { de: "Die Systemlandschaften und der Transportpfad sind in diesem Space fest definiert und können nicht geändert werden.", en: "The system landscapes and the transport path are fixed for this space and cannot be changed." },
  "s0.next": { de: "Weiter zu Landschaften", en: "Continue to Landscapes" },
  "role.src": { de: "Quelle", en: "Source" },
  "role.tgt": { de: "Ziel", en: "Target" },
  "role.rel": { de: "Freigabe", en: "Release" },
  "role.pipe": { de: "Pipeline", en: "Pipeline" },
  "s1.h2": { de: "Landschaften", en: "Landscapes" },
  "s1.p": { de: "Quelle und Ziel ergeben sich aus dem Space. Der iFlow-Transport läuft bis QAS, der Release nach PROD erfolgt später per Freigabe.", en: "Source and target derive from the space. The iFlow transport runs up to QAS, the release to PROD happens later via approval." },
  "s1.landTitle": { de: "Systemlandschaft", en: "System landscape" },
  "s1.meta": { de: "{name} · {n} Systeme", en: "{name} · {n} systems" },
  "s1.info": { de: "iFlow-Transport: {src} {cx} {tgt} · Partner Directory: {tgt} + {rel} · Release nach {rel} per Freigabe", en: "iFlow transport: {src} {cx} {tgt} · Partner Directory: {tgt} + {rel} · release to {rel} via approval" },
  "s1.infoSap": { de: "iFlow-Transport: {src} {cx} {tgt} · Release nach {rel} per Freigabe", en: "iFlow transport: {src} {cx} {tgt} · release to {rel} via approval" },
  "s1.werkTitle": { de: "Werkstransport im Ziel", en: "Plant transport in the target" },
  "s1.werkMeta": { de: "Werkstransport · {x} von {n} Werken ausgewählt", en: "Plant transport · {x} of {n} plants selected" },
  "s1.werkNone": { de: "Kein Werk ausgewählt", en: "No plant selected" },
  "s1.werkSub": { de: "Kennung wird an Paket und iFlows angehängt", en: "Suffix is appended to package and iFlows" },
  "s1.qasNote": { de: "Jedes Werk erhält seine eigene Kennung", en: "Each plant gets its own suffix" },
  "s1.next": { de: "Weiter zu Package", en: "Continue to Package" },
  "s2.h2": { de: "Package", en: "Package" },
  "s2.p": { de: "Wählen Sie das Quellpaket aus der DEV-Instanz. Der Vergleich gegen das Ziel läuft im nächsten Schritt automatisch.", en: "Select the source package from the DEV instance. The comparison against the target runs automatically in the next step." },
  "s2.search": { de: "Paket suchen ...", en: "Search packages ..." },
  "s2.sel": { de: "{name} gewählt", en: "{name} selected" },
  "s2.none": { de: "Kein Paket gefunden", en: "No package found" },
  "s2.ver": { de: "Version {v}", en: "Version {v}" },
  "s2.arts": { de: "{n} Artefakte", en: "{n} artifacts" },
  "s2.mod": { de: "Geändert {d}", en: "Modified {d}" },
  "s2.next": { de: "Weiter zu Artefakten", en: "Continue to Artifacts" },
  "s3.h2": { de: "Artefakte", en: "Artifacts" },
  "s3.p": { de: "Vergleich Quelle gegen Ziel pro Werk. Beim Werkstransport sind nur die Werk-Zeilen wählbar, der Plain-iFlow verbleibt in der Quelle.", en: "Comparison of source against target per plant. For plant transports only the plant rows are selectable, the plain iFlow stays in the source." },
  "s3.loading": { de: "Ziel-Inhalte werden geladen", en: "Loading target content" },
  "s3.par": { de: "pro Werk · {n} parallel", en: "per plant · {n} in parallel" },
  "s3.single": { de: "Single-Transport", en: "Single transport" },
  "s3.ph1": { de: "Authentifizierung gegen Ziel", en: "Authenticating against target" },
  "s3.ph2": { de: "Package-Inhalt aus Quelle abrufen", en: "Fetching package content from source" },
  "s3.ph3": { de: "Ziel-Artefakte und Versionen lesen", en: "Reading target artifacts and versions" },
  "s3.ph4": { de: "Global References auflösen", en: "Resolving global references" },
  "s3.ph5": { de: "Diff erzeugen", en: "Generating diff" },
  "s3.tableTitle": { de: "Artefakte im Vergleich", en: "Artifact comparison" },
  "th.art": { de: "Artefakt", en: "Artifact" },
  "th.type": { de: "Typ", en: "Type" },
  "th.src": { de: "Quelle", en: "Source" },
  "th.tgt": { de: "Ziel", en: "Target" },
  "th.status": { de: "Status", en: "Status" },
  "th.action": { de: "Aktion", en: "Action" },
  "th.param": { de: "Parameter", en: "Parameter" },
  "st.new": { de: "Neu", en: "New" },
  "st.update": { de: "Update", en: "Update" },
  "st.identical": { de: "Identisch", en: "Identical" },
  "st.draft": { de: "Draft", en: "Draft" },
  "s3.plain": { de: "{n} Werke · Plain-iFlow nicht transportierbar", en: "{n} plants · plain iFlow not transportable" },
  "s3.draftLast": { de: "{id} · letzte Version {v}", en: "{id} · last version {v}" },
  "s3.lastVer": { de: "letzte Version {v}", en: "last version {v}" },
  "s3.view": { de: "Änderungen einsehen", en: "View changes" },
  "s3.release": { de: "Version releasen", en: "Release version" },
  "s3.doRel": { de: "Releasen", en: "Release" },
  "s3.refs": { de: "Globale Referenzen", en: "Global references" },
  "s3.refsMeta": { de: "werden vor den iFlows transportiert", en: "transported before the iFlows" },
  "s3.ident": { de: "identisch - kein Transport nötig", en: "identical - no transport needed" },
  // The reference cannot be found on the source tenant (backend: resolvable=false).
  // It is deselected automatically and not transported.
  "s3.refUnres": { de: "kann nicht aufgelöst werden", en: "cannot be resolved" },
  "s3.min": { de: "Mindestens ein Artefakt auswählen", en: "Select at least one artifact" },
  "s3.selN": { de: "{n} Zielartefakte ausgewählt", en: "{n} target artifacts selected" },
  "s3.comparing": { de: "Vergleich läuft ...", en: "Comparing ..." },
  "s3.next": { de: "Weiter zu Konfiguration", en: "Continue to Configuration" },
  "s4.h2": { de: "Konfiguration", en: "Configuration" },
  "s4.p": { de: "Externalized Parameters pro Werk - jedes Werk kann eigene Adressen erhalten. Pflichtfelder für Sender und Receiver müssen gesetzt sein.", en: "Externalized parameters per plant - each plant can have its own addresses. Required fields for sender and receiver must be set." },
  "s4.progress": { de: "{x} von {y} Pflichtfeldern ausgefüllt", en: "{x} of {y} required fields filled" },
  "s4.activeTab": { de: " · aktiv: {name}", en: " · active: {name}" },
  "s4.fillAll": { de: "Alle Vorschlagswerte übernehmen", en: "Apply all suggested values" },
  "s4.grpSender": { de: "Sender Konfiguration", en: "Sender configuration" },
  "s4.grpReceiver": { de: "Receiver Konfiguration", en: "Receiver configuration" },
  "s4.grpGeneral": { de: "Allgemein", en: "General" },
  "s4.required": { de: "Pflicht", en: "Required" },
  "pst.req": { de: "Pflichtfeld", en: "Required" },
  "pst.tgt": { de: "Ziel", en: "Target" },
  "pst.mod": { de: "Geändert", en: "Modified" },
  "pst.std": { de: "Standard", en: "Default" },
  "s4.missing": { de: "{n} Pflichtfelder offen", en: "{n} required fields open" },
  "s4.allset": { de: "Alle Pflichtfelder gesetzt", en: "All required fields set" },
  "s4.choose": { de: "Bitte wählen ...", en: "Please select ..." },
  "s4.cred": { de: '<b style="color:var(--t2)">Referenzierte Credentials (optional):</b> Credentials werden nicht transportiert, nur auf Existenz im Ziel geprüft.', en: '<b style="color:var(--t2)">Referenced credentials (optional):</b> Credentials are not transported, only checked for existence in the target.' },
  "s4.noneWerk": { de: "Keine iFlows für dieses Werk ausgewählt.", en: "No iFlows selected for this plant." },
  "s4.next": { de: "Weiter zu Review & Ausführung", en: "Continue to Review & Execution" },
  // Warning popup shown when the user continues with incomplete externalized
  // parameters. A field is allowed to stay empty; the target tenant
  // validates its own required fields.
  "s4.warnTitle": { de: "Nicht alle Parameter gesetzt", en: "Not all parameters are set" },
  "s4.warnBody": { de: "{n} externalized Parameter sind noch leer. Sie werden leer ans Ziel übergeben - der Ziel-Tenant weist echte Pflichtfelder beim Deploy zurück. Fortfahren?", en: "{n} externalized parameters are still empty. They will be passed to the target empty - the target tenant rejects real required fields at deploy time. Continue?" },
  "s4.warnBodyOne": { de: "Ein externalized Parameter ist noch leer. Er wird leer ans Ziel übergeben - der Ziel-Tenant weist echte Pflichtfelder beim Deploy zurück. Fortfahren?", en: "One externalized parameter is still empty. It will be passed to the target empty - the target tenant rejects real required fields at deploy time. Continue?" },
  "s4.warnCancel": { de: "Zurück zur Konfiguration", en: "Back to configuration" },
  "s4.warnGo": { de: "Trotzdem weiter", en: "Continue anyway" },
  "s5.h2": { de: "Review & Ausführung", en: "Review & Execution" },
  "s5.p": { de: "Der Payload wird nach Git gesammelt, das ausgewählte Partner Directory reist im Snapshot mit und die GitHub Actions Pipeline übernimmt den kompletten Transport. Der Release nach PROD wird anschließend hier freigegeben.", en: "The payload is collected into Git, the selected Partner Directory travels along in the snapshot and the GitHub Actions pipeline performs the entire transport. The release to PROD is then approved right here." },
  "mf.space": { de: "Space", en: "Space" },
  "mf.pkg": { de: "Paket", en: "Package" },
  "mf.iflows": { de: "iFlows", en: "iFlows" },
  "mf.refs": { de: "Globale Referenzen", en: "Global references" },
  "mf.cfg": { de: "Konfiguration", en: "Configuration" },
  "mf.sel": { de: "{n} ausgewählt", en: "{n} selected" },
  "mf.rows": { de: "{n} Zielartefakte", en: "{n} target artifacts" },
  "mf.rowsW": { de: "{n} Zielartefakte über {m} Werke", en: "{n} target artifacts across {m} plants" },
  "mf.req": { de: "{n} Pflichtparameter", en: "{n} required parameters" },
  "mf.allset": { de: "alle gesetzt · eine Parameterdatei je Paket", en: "all set · one parameter file per package" },
  "cf.iflows": { de: "{n} iFlows", en: "{n} iFlows" },
  // SAP mode: what runs differently goes where the PD switch would otherwise be.
  "s5.sapModus": { de: "Transport über SAPs Workflows", en: "Transport via SAP's workflows" },
  "s5.sapModusSub": { de: "Es wandert das ganze Paket. SAP löscht es im Ziel und legt es neu an - bricht der Lauf zwischen Löschen und Hochladen ab, bleibt das Paket dort weg. Partner-Directory-Einträge fahren auf diesem Weg nicht mit.", en: "The whole package is transported. SAP deletes it in the target and recreates it - if the run breaks between delete and upload, the package stays gone. Partner Directory entries do not travel along on this route." },
  "s5.pd": { de: "Partner Directories replizieren", en: "Replicate Partner Directories" },
  "s5.pdSub": { de: "{n} Partner-IDs referenziert · +{m} verkettet · reisen im Snapshot mit, Übernahme durch den Ziel-Workflow", en: "{n} partner IDs referenced · +{m} chained · travel along in the snapshot, applied by the target workflow" },
  "s5.pdAutoTitle": { de: "Automatisch erkannt", en: "Automatically detected" },
  "s5.pdAutoSub": { de: "Aus den ausgewählten iFlows abgeleitet - vorausgewählt", en: "Derived from the selected iFlows - preselected" },
  "s5.pdAutoNone": { de: "Keine Partner-IDs in den ausgewählten iFlows referenziert", en: "No partner IDs referenced in the selected iFlows" },
  "s5.pdAutoLoading": { de: "Referenzen werden ermittelt ...", en: "Detecting references ..." },
  "s5.pdRolePrimary": { de: "direkt referenziert", en: "directly referenced" },
  "s5.pdRoleRelated": { de: "verkettet", en: "chained" },
  // The backend reports ids detected via header (SAP_Sender/SAP_SenderInterface)
  // with extra context: sender/interface shown as a quiet hint.
  "s5.pdRoleHeader": { de: "aus Header erkannt", en: "detected from header" },
  "s5.pdHeaderCtx": { de: "Sender {s} · Interface {i}", en: "sender {s} · interface {i}" },
  "s5.pdHeaderCtxShort": { de: "Sender {s}", en: "sender {s}" },
  "s5.pdCustomTitle": { de: "Eigene Einträge hinzufügen", en: "Add own entries" },
  "s5.pdCustomSub": { de: "Weitere Kennungen aus der Quelle mit-transportieren", en: "Include additional identifiers from the source" },
  "s5.pdCustomLoading": { de: "Einträge werden geladen ...", en: "Loading entries ..." },
  "s5.pdCustomEmpty": { de: "Keine Einträge im Partner Directory der Quelle", en: "No entries in the source Partner Directory" },
  "s5.pdCustomSearch": { de: "Kennung suchen ...", en: "Search identifier ..." },
  "s5.pdAll": { de: "Alle", en: "All" },
  "s5.pdNone": { de: "Keine", en: "None" },
  "s5.pdSelCount": { de: "{n} von {m} gewählt", en: "{n} of {m} selected" },
  "s5.pdSystem": { de: "Systemeigene Kennung - nicht transportierbar", en: "System identifier - not transportable" },
  "s5.pdSelSummary": { de: "{n} Kennung(en) werden nach Git und in die Ziele übernommen", en: "{n} identifier(s) will be pushed to Git and to the targets" },
  "s5.pdSelSummaryNone": { de: "Keine Kennung ausgewählt - es werden keine PD-Einträge übertragen", en: "No identifier selected - no PD entries will be transported" },
  // Per-id stage toggle, only visible with more than one forward stage.
  "s5.pdStagesLbl": { de: "Stufen", en: "Stages" },
  "s5.pdStagesHint": {
    de: "Legt fest, für welche Stufen dieses Partner Directory mittransportiert wird. Ohne Einschränkung greift die Kennung auf allen Stufen (heutiges Verhalten).",
    en: "Controls which stages this partner directory is applied to. Without a restriction, the identifier applies to all stages (current behavior).",
  },
  "s5.pdStagesAria": { de: "Stufen für Kennung {pid}", en: "Stages for identifier {pid}" },
  "s5.pdStageOn": { de: "{code} eingeschlossen - klicken zum Ausschließen", en: "{code} included - click to exclude" },
  "s5.pdStageOff": { de: "{code} ausgeschlossen - klicken zum Einschließen", en: "{code} excluded - click to include" },
  "s5.pdCountsMeta": { de: "{s} String · {b} Binär · {a} Alt", en: "{s} string · {b} binary · {a} alt" },
  "s5.pdInfoTitle": { de: "Was wird automatisch erkannt?", en: "What is detected automatically?" },
  "s5.pdInfoDirect": { de: "Direkte Verweise im iFlow: pd-Ausdrücke, partner.id-Properties und Skript-Zugriffe auf das Partner Directory.", en: "Direct references in the iFlow: pd expressions, partner.id properties and script access to the Partner Directory." },
  "s5.pdInfoAddr": { de: "Pipeline-Routing: Partner, deren Einträge auf die ProcessDirect-Adressen des iFlows zeigen (z. B. receiverDetermination).", en: "Pipeline routing: partners whose entries point to the iFlow's ProcessDirect addresses (e.g. receiverDetermination)." },
  "s5.pdInfoChain": { de: "Verkettete Partner: Business-Systeme, auf die gefundene Einträge weiterverweisen. Sie erscheinen als \"+n verkettet\".", en: "Chained partners: business systems that detected entries refer to. Shown as \"+n chained\"." },
  "s5.pdInfoMiss": { de: "Nicht automatisch erkennbar: Partner-IDs, die erst zur Laufzeit entstehen (z. B. aus Headern oder Properties zusammengesetzt). Fehlt ein Partner in der Zählung, bitte über die Seite Partner Directory manuell prüfen und nachziehen.", en: "Not detectable automatically: partner IDs built at runtime (e.g. composed from headers or properties). If a partner is missing from the count, please check and add it manually via the Partner Directory page." },
  "s5.noPipeTitle": { de: "Keine aktive CI/CD-Pipeline", en: "No active CI/CD pipeline" },
  "s5.noPipeToken": { de: "Die GitHub-Verbindung wurde getrennt - ohne sie kann nicht transportiert oder freigegeben werden. Verbinde GitHub im CI/CD Setup neu.", en: "The GitHub connection was removed - transports and releases are not possible without it. Reconnect GitHub in the CI/CD setup." },
  "s5.noPipeCfg": { de: "Für diesen Space ist keine CI/CD-Pipeline aufgesetzt - es kann nicht transportiert werden. Richte die Pipeline im CI/CD Setup ein.", en: "No CI/CD pipeline is set up for this space - transporting is not possible. Set up the pipeline in the CI/CD setup." },
  "s5.noPipeLink": { de: "Zum CI/CD Setup", en: "Open CI/CD setup" },
  "s5.start": { de: "Transport starten (CI/CD)", en: "Start transport (CI/CD)" },
  "s5.running": { de: "Läuft ...", en: "Running ..." },
  "s5.execTitle": { de: "Ausführung", en: "Execution" },
  "s5.metaWith": { de: "gestartet von {user} · mit Partner Directory", en: "started by {user} · with Partner Directory" },
  "s5.metaWithout": { de: "gestartet von {user} · ohne Partner Directory", en: "started by {user} · without Partner Directory" },
  "ph.git": { de: "Snapshot nach Git", en: "Snapshot to Git" },
  "ph.wf": { de: "Workflow starten", en: "Start workflow" },
  "log.zip": { de: "ZIP laden: {name}", en: "Loading ZIP: {name}" },
  "log.extract": { de: "Entpacken nach IntegrationPackages/{pkg}/", en: "Extracting to IntegrationPackages/{pkg}/" },
  "log.cfg": { de: "Parameterdatei für {id} geschrieben ({n} Pakete)", en: "Parameter file for {id} written ({n} packages)" },
  "log.commit": { de: "Snapshot geschrieben", en: "Snapshot written" },
  "log.pdSnap": { de: "{n} Partner-Directory-Kennungen in den Snapshot aufgenommen", en: "{n} partner directory IDs added to the snapshot" },
  "log.wf": { de: "{wf} · targetStage: {s}", en: "{wf} · targetStage: {s}" },
  "log.queued": { de: "Run #{n} in Warteschlange gestellt", en: "Run #{n} queued" },
  "log.pending": { de: "Freigabe angefordert - Transport wartet auf Genehmigung", en: "Approval requested - transport waiting for approval" },
  "s5.pendingApproval": { de: "Freigabe angefordert - Transport wartet auf Genehmigung", en: "Approval requested - transport is waiting for approval" },
  "s5.done": { de: "abgeschlossen", en: "completed" },
  "run.running": { de: "Läuft", en: "Running" },
  "run.ok": { de: "Erfolgreich", en: "Successful" },
  "run.failed": { de: "Fehlgeschlagen", en: "Failed" },
  "job.checkout": { de: "Checkout Repository", en: "Checkout repository" },
  "job.prep": { de: "Stage-Umgebung {code} vorbereiten", en: "Prepare stage environment {code}" },
  "job.upload": { de: "{name} hochladen + konfigurieren", en: "Upload + configure {name}" },
  "job.deploy": { de: "Artefakte deployen", en: "Deploy artifacts" },
  "job.smoke": { de: "Smoke-Check auf {code}", en: "Smoke check on {code}" },
  "s5.qasOk": { de: "Transport nach QAS erfolgreich", en: "Transport to QAS successful" },
  "s5.qasOkSub": { de: "alle Artefakte deployt und verifiziert", en: "all artifacts deployed and verified" },
  "rel.title": { de: "Transport-Freigabe", en: "Transport Release" },
  "rel.meta": { de: "Release-Kandidat · aufgelaufen seit letztem PROD-Release", en: "Release candidate · accumulated since the last PROD release" },
  "rt.iflows": { de: "iFlows", en: "iFlows" },
  "rt.pushes": { de: "Pushes DEV {cx} QAS", en: "Pushes DEV {cx} QAS" },
  // "rt.werke" names the plants of THIS transport (the summary at the top), "rt.pakete" the
  // number of release-ready packages in the release block. Two different things, two strings.
  "rt.werke": { de: "Werke", en: "Plants" },
  "rt.pakete": { de: "Pakete", en: "Packages" },
  "rt.prod": { de: "Ziel PROD · Artefakte", en: "Target PROD · artifacts" },
  "rel.accum": { de: "Aufgelaufen für den Release", en: "Accumulated for the release" },
  // Count and timestamp come from the candidate data and vary per iFlow;
  // neither may be hardcoded.
  "rel.push": { de: "{n}× DEV {cx} QAS · {wann}", en: "{n}× DEV {cx} QAS · {wann}" },
  "rel.today": { de: "1× DEV {cx} QAS · heute", en: "1× DEV {cx} QAS · today" },
  "rel.noPkg": { de: "Kein Release-Paket bestimmbar", en: "No release package identifiable" },
  "rel.pickPkg": { de: "Welches Paket soll nach PROD?", en: "Which package goes to PROD?" },
  "rel.pkgMeta": { de: "{n} iFlows · zuletzt {wann}", en: "{n} iFlows · last {wann}" },
  "rel.reason": { de: "Grund der Freigabe (Pflichtfeld)", en: "Release reason (required)" },
  "rel.ph": { de: "z. B. Sprint-Abschluss KW 28, getestet auf QAS durch Fachbereich ...", en: "e.g. sprint close CW 28, tested on QAS by the business department ..." },
  "rel.min3": { de: "Mindestens 3 Zeichen", en: "At least 3 characters" },
  "rel.ready": { de: "Bereit zur Freigabe", en: "Ready for release" },
  "rel.btn": { de: "Release nach PROD freigeben", en: "Approve release to PROD" },
  "rel.running": { de: "Release läuft ...", en: "Release running ..." },
  "rel.empty": { de: "Kein Release-Kandidat vorhanden", en: "No release candidate available" },
  "plog.tag": { de: "Git-Tag release/{pkg} erstellt", en: "Git tag release/{pkg} created" },
  "plog.dispatch": { de: "Workflow-Dispatch · targetStage: prod", en: "Workflow dispatch · targetStage: prod" },
  "plog.upload": { de: "Release-Job gestartet", en: "Release job started" },
  "plog.verify": { de: "Freigabe bestätigt", en: "Approval confirmed" },
  "fin.h": { de: "Transport abgeschlossen", en: "Transport completed" },
  "fin.txt": { de: "{name} · Freigabe nach PROD ausgelöst", en: "{name} · release to PROD triggered" },
  "fin.restart": { de: "Neuen Transport starten", en: "Start new transport" },
  "s5.footHint": { de: "Nach dem Start übernimmt die Pipeline - dieser Schritt bleibt live beobachtbar", en: "After the start the pipeline takes over - this step stays observable live" },
  "modal.title": { de: "Änderungen einsehen", en: "View changes" },
  "modal.scripts": { de: "Scripte", en: "Scripts" },
  "modal.bpmn": { de: "BPMN", en: "BPMN" },
  "modal.vs": { de: "{a} · Quelle {sv} gegen Ziel {tv}", en: "{a} · source {sv} vs target {tv}" },
  "s0.planned": { de: "Geplante Transporte ({n})", en: "Scheduled transports ({n})" },
  "s0.plannedSt": { de: "Geplant", en: "Scheduled" },
  "s0.plannedWhen": { de: "geplant", en: "scheduled" },
  "s0.plannedNone": { de: "Keine geplanten Transporte", en: "No scheduled transports" },
  "s0.chain": { de: "Transportkette {path}.", en: "Transport chain {path}." },
  "s0.chainW": { de: "Transportkette {path} mit {n} Werken.", en: "Transport chain {path} with {n} plants." },
  "s0.noDev": { de: "Keine DEV-Instanz (Tag dev) in dieser Schiene.", en: "No DEV instance (tag dev) in this chain." },
  "s0.noQas": { de: "Keine QAS-Instanz (Tag qas) in dieser Schiene - der Transport geht immer zuerst nach QAS.", en: "No QAS instance (tag qas) in this chain - the transport always goes to QAS first." },
  // Stages can be combined freely (DEV, QAS, PRE-PROD, PROD; two are enough),
  // so these messages name what is missing rather than a specific stage.
  "s0.noStage": { de: "Keine Instanz mit Stufen-Tag in dieser Schiene. Vergib einer Instanz den Tag dev, qas, preprod oder prod.", en: "No instance with a stage tag in this chain. Assign the tag dev, qas, preprod or prod to an instance." },
  "s0.noTarget": { de: "Nur eine Stufe getaggt - es fehlt ein Ziel weiter vorn in der Reihenfolge DEV, QAS, PRE-PROD, PROD.", en: "Only one stage tagged - a later target in the order DEV, QAS, PRE-PROD, PROD is missing." },
  "s2.more": { de: "Mehr Pakete anzeigen ({n} verbleibend)", en: "Show more packages ({n} remaining)" },
  "s3.all": { de: "Alle ({n})", en: "All ({n})" },
  "s3.orph": { de: "Veraltete Artefakte im Ziel", en: "Outdated artifacts in the target" },
  "s3.orphMeta": { de: "Bereinigung ist vorübergehend deaktiviert", en: "cleanup is temporarily disabled" },
  "st.orphan": { de: "Orphan", en: "Orphan" },
  "s4.connected": { de: "Verbunden", en: "Connected" },
  "s4.targetInst": { de: "Ziel-Instanz", en: "Target instance" },
  // Multi-stage header: each stage shows its code and instance name.
  // The inheritance hint only appears with more than one forward stage.
  "s4.stagesN": { de: "{n} Stufen konfigurierbar", en: "{n} stages configurable" },
  "s4.stageInheritHint": {
    de: "Ein leeres Stufen-Feld übernimmt den Wert der vorigen Stufe. Nur abweichende Werte werden als Overlay in Git abgelegt.",
    en: "An empty stage field inherits the value from the previous stage. Only differing values are stored as an overlay in Git."
  },
  // Stage configuration: the base value is set once and inherited by every
  // following stage. A deviation is added deliberately per stage via "+".
  "s4.hdrBasis": { de: "Basiswert", en: "Base value" },
  "s4.hdrOverlay": { de: "Abweichung optional", en: "Override optional" },
  "s4.inherits": { de: "Erbt: {v}", en: "Inherits: {v}" },
  "s4.inheritEmpty": { de: "Erbt: -", en: "Inherits: -" },
  "s4.addOverride": { de: "Abweichung", en: "Override" },
  "s4.setBaseFirst": { de: "Erst Basiswert setzen, dann ist eine Abweichung möglich", en: "Set the base value first, then an override is possible" },
  "s4.edApply": { de: "Übernehmen", en: "Apply" },
  "s4.edCancel": { de: "Abbrechen", en: "Cancel" },
  "s4.edRemove": { de: "Abweichung entfernen", en: "Remove override" },
  "s4.edSourceHint": { de: "Vorschlag aus Quelle: {v}", en: "Suggestion from source: {v}" },
  "s4.edInheritHint": { de: "Vorbelegung aus {stage}: {v}", en: "Prefilled from {stage}: {v}" },
  "s4.edAriaBasis": { de: "Basiswert für {param} setzen", en: "Set base value for {param}" },
  "s4.edAriaOverride": { de: "Abweichung für {param} auf {stage} setzen", en: "Set override for {param} on {stage}" },
  "s4.edResetTitle": { de: "Auf geerbten Wert zurücksetzen", en: "Reset to inherited value" },
  "s4.divergeTitle": { de: "Abweichend vom Basiswert", en: "Differs from base value" },
  "s4.rowSet": { de: "gesetzt", en: "set" },
  "s4.rowOpen": { de: "offen", en: "open" },
  "s4.rowFromTarget": { de: "aus Ziel", en: "from target" },
  // Where a value comes from decides whether it can be trusted: "from Git" is the maintained
  // state, "from target" only the tenant's current value.
  "s4.rowFromGit": { de: "aus Git", en: "from Git" },
  "s4.rowDiverges": { de: "abweichend", en: "diverging" },
  "s4.rowEditing": { de: "wird bearbeitet", en: "being edited" },
  "s4.rowBaseMissing": { de: "Basiswert fehlt", en: "base value missing" },
  "err.instances": { de: "Instanzen konnten nicht geladen werden", en: "Failed to load instances" },
  "err.packages": { de: "Pakete konnten nicht geladen werden", en: "Failed to load packages" },
  "err.precheck": { de: "Vergleich fehlgeschlagen", en: "Comparison failed" },
  "err.snapshot": { de: "Snapshot fehlgeschlagen", en: "Snapshot failed" },
  "err.dispatch": { de: "Workflow-Start fehlgeschlagen", en: "Workflow dispatch failed" },
  "err.release": { de: "Release fehlgeschlagen", en: "Release failed" },
  "err.retry": { de: "Erneut versuchen", en: "Retry" },
  "common.loading": { de: "Wird geladen ...", en: "Loading ..." },
};

export function t(key, vars, lang) {
  const L = lang || (typeof window !== "undefined" ? window.__iioLang || "de" : "de");
  let s = (T[key] || {})[L];
  if (s == null) s = key;
  if (!vars) return s;
  // React elements as placeholder values (e.g. {cx} = <Cx/>) cannot be
  // interpolated via string join, or the UI would render "[object Object]".
  const hasNode = Object.values(vars).some((v) => v !== null && typeof v === "object");
  if (!hasNode) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.split("{" + k + "}").join(v);
    }
    return s;
  }
  let parts = [s];
  for (const [k, v] of Object.entries(vars)) {
    const next = [];
    for (const p of parts) {
      if (typeof p !== "string") { next.push(p); continue; }
      const segs = p.split("{" + k + "}");
      segs.forEach((seg, i) => {
        if (i > 0) next.push(React.isValidElement(v) ? React.cloneElement(v, { key: k + i }) : v);
        if (seg) next.push(seg);
      });
    }
    parts = next;
  }
  return parts;
}

const LS_KEY = "iio-lang";
let listeners = [];

function readInitial() {
  if (typeof window === "undefined") return "de";
  try {
    const v = window.localStorage.getItem(LS_KEY);
    if (v === "de" || v === "en") return v;
  } catch {}
  return "de";
}

export function useLang() {
  const [lang, setLangState] = useState(readInitial);

  useEffect(() => {
    if (typeof window !== "undefined") window.__iioLang = lang;
  }, [lang]);

  useEffect(() => {
    const cb = (nl) => setLangState(nl);
    listeners.push(cb);
    return () => {
      listeners = listeners.filter((l) => l !== cb);
    };
  }, []);

  const setLang = useCallback((nl) => {
    try {
      window.localStorage.setItem(LS_KEY, nl);
    } catch {}
    if (typeof window !== "undefined") window.__iioLang = nl;
    listeners.forEach((l) => l(nl));
  }, []);

  const tt = useCallback((key, vars) => t(key, vars, lang), [lang]);

  return { lang, setLang, t: tt };
}
